export default __webpack_public_path__ + "static/media/chevron-right.4615ad65.svg";